export default __webpack_public_path__ + "assets/images/dash-indicator.628333221cff9ae3950a9b144bd08d1d.png";